import { roofStructureData } from "./structureFunction";
import * as htmlToImage from "html-to-image";
import { updateRoofDetails } from "../../../Features/quantityInfo";
import { panelInformation } from "../../DataFiles/panelInformation";
import { calculateLandscapePlacement } from "./structurePlacementFunction/landscapeStructure";
import { calculatePortraitPlacement } from "./structurePlacementFunction/portraitStructure";
import { calculateCarportStructure } from "./structurePlacementFunction/doubleCarportPlacement";
import { calculateCustomizedStructure } from "./structurePlacementFunction/customizedStructure";
import { updateProjectImg } from "../../../Features/projectImage";
import { generationLosses } from "../Functions/generationCalculate";
import {
  // calMultipleStr,
  getPixelsPerMeter,
} from "./structurePlacementFunction/smithStructure";

const isPointInPolygon = (x, y, polygon) => {
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].x,
      yi = polygon[i].y;
    const xj = polygon[j].x,
      yj = polygon[j].y;
    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
};

const doLinesIntersect = (line1, line2) => {
  const { x: x1, y: y1 } = line1[0];
  const { x: x2, y: y2 } = line1[1];
  const { x: x3, y: y3 } = line2[0];
  const { x: x4, y: y4 } = line2[1];

  const ua =
    ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) /
    ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1));
  const ub =
    ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) /
    ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1));

  return ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1;
};

export const isImageInsideObstacle = (
  x,
  y,
  width,
  height,
  obstacleCoordinates
) => {
  const topLeftX = x;
  const topLeftY = y;
  const topRightX = x + width;
  const topRightY = y;
  const bottomLeftX = x;
  const bottomLeftY = y + height;
  const bottomRightX = x + width;
  const bottomRightY = y + height;

  for (let i = 0; i < obstacleCoordinates.length; i++) {
    const polygon = obstacleCoordinates[i].updatedPoints;

    if (
      isPointInPolygon(topLeftX, topLeftY, polygon) ||
      isPointInPolygon(topRightX, topRightY, polygon) ||
      isPointInPolygon(bottomLeftX, bottomLeftY, polygon) ||
      isPointInPolygon(bottomRightX, bottomRightY, polygon)
    ) {
      return false; // Image intersects with obstacle
    }

    for (let j = 0; j < polygon.length; j++) {
      const line = [polygon[j], polygon[(j + 1) % polygon.length]];

      if (
        doLinesIntersect(line, [
          { x: topLeftX, y: topLeftY },
          { x: topRightX, y: topRightY },
        ]) ||
        doLinesIntersect(line, [
          { x: topRightX, y: topRightY },
          { x: bottomRightX, y: bottomRightY },
        ]) ||
        doLinesIntersect(line, [
          { x: bottomRightX, y: bottomRightY },
          { x: bottomLeftX, y: bottomLeftY },
        ]) ||
        doLinesIntersect(line, [
          { x: bottomLeftX, y: bottomLeftY },
          { x: topLeftX, y: topLeftY },
        ])
      ) {
        return false; // Image intersects with obstacle line
      }
    }
  }

  return true;
};

export const isPositionFree = (x, y, width, height, images) => {
  for (const image of images) {
    if (
      x + width > image.x &&
      x < image.x + image.width &&
      y + height > image.y &&
      y < image.y + image.height
    ) {
      return false;
    }
  }
  return true;
};

export const canPlaceImage = (x, y, width, height, polygonCoordinates) => {
  const topLeftX = x;
  const topLeftY = y;
  const topRightX = x + width;
  const topRightY = y;
  const bottomLeftX = x;
  const bottomLeftY = y + height;
  const bottomRightX = x + width;
  const bottomRightY = y + height;
  for (let j = 0; j < polygonCoordinates.length; j++) {
    const line = [
      polygonCoordinates[j],
      polygonCoordinates[(j + 1) % polygonCoordinates.length],
    ];

    if (
      doLinesIntersect(line, [
        { x: topLeftX, y: topLeftY },
        { x: topRightX, y: topRightY },
      ]) ||
      doLinesIntersect(line, [
        { x: topRightX, y: topRightY },
        { x: bottomRightX, y: bottomRightY },
      ]) ||
      doLinesIntersect(line, [
        { x: bottomRightX, y: bottomRightY },
        { x: bottomLeftX, y: bottomLeftY },
      ]) ||
      doLinesIntersect(line, [
        { x: bottomLeftX, y: bottomLeftY },
        { x: topLeftX, y: topLeftY },
      ])
    ) {
      return false; // Image intersects with obstacle line
    }
  }
  if (
    isPointInPolygon(topLeftX, topLeftY, polygonCoordinates) &&
    isPointInPolygon(topRightX, topRightY, polygonCoordinates) &&
    isPointInPolygon(bottomLeftX, bottomLeftY, polygonCoordinates) &&
    isPointInPolygon(bottomRightX, bottomRightY, polygonCoordinates)
  ) {
    return true;
  }

  return false;
};

export const takeScreenshot = async (mapRef, dispatch) => {
  if (!mapRef) {
    return false;
  }
  try {
    const image = await htmlToImage.toJpeg(mapRef.current);
    dispatch(updateProjectImg({ structureImage: image }));
    // sessionStorage.setItem("imageSrc", JSON.stringify(image));

    return true; // Indicate success
  } catch (error) {
    console.error("Error taking screenshot:", error);
    return false; // Indicate failure
  }
};

export const handleClick = ({
  roofInfo,
  structureItem,
  dispatch,
  abstacles,
  limitCapacity,
  quantityInfo,
  roofDetail,
}) => {
  const roofPolygons = roofInfo?.value?.polygonCoordinates
    ? roofInfo.value.polygonCoordinates
    : [];

  let pixelMultiple = getPixelsPerMeter(roofInfo);

  const rowDistance =
    roofDetail.customCapacityType === "Auto"
      ? structureItem.gap * 1000
      : roofDetail.rowDistance;
  const panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  const panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  const imgSrc = structureItem.structureImgSrc;
  const imgDimension = {
    height: structureItem.height * pixelMultiple,
    width: panel.height * pixelMultiple,
    gap: (rowDistance / 1000) * pixelMultiple,
  };

  const newImages = [];
  const polygonCoordinates = roofPolygons[quantityInfo.roofNo].updatedPoints;
  const adjustedPoints = polygonCoordinates.flatMap((point) => [
    point.x + 0,
    point.y + 0,
  ]);
  const minX = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const minY = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 1));
  const maxX = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const maxY = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 1));

  const angleDegrees = 0;
  let x = minX;
  let y = minY + pixelMultiple * 0.305;
  let col = 0;
  let row = 0;
  let isFirstRowPlaced = false;
  let updateCondition = true;
  while (y <= maxY) {
    while (x <= maxX) {
      if (limitCapacity !== 0 && newImages.length >= limitCapacity) {
        updateCondition = false;
      }
      if (
        updateCondition &&
        canPlaceImage(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          polygonCoordinates,
          angleDegrees
        ) &&
        isPositionFree(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          newImages
        ) &&
        isImageInsideObstacle(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          abstacles
        )
      ) {
        col++;
        if (col === 1) {
          x += pixelMultiple * 0.305;
          isFirstRowPlaced = true;
          row++;
          if (row === 1) {
            y += pixelMultiple * 0.305;
          }
        }
        const imageId =
          Number(Math.floor(Math.random() * 499)) *
          Number(Math.floor(Math.random() * 499));
        const newImage = {
          id: imageId,
          src: imgSrc,
          x: x,
          y: y,
          width: imgDimension.width,
          height: imgDimension.height,
          type: structureItem.name,
          gap: imgDimension.gap,
          angleDegree: 0,
        };
        newImages.push(newImage);
        x += imgDimension.width;
      } else {
        x += 1;
      }
    }
    col = 0;
    x = minX;
    if (row === 0 && !isFirstRowPlaced) {
      y += 1;
    } else {
      y += imgDimension.height + imgDimension.gap;
    }
  }

  calculatedStructure({
    newImages,
    structureItem,
    dispatch,
    roofDetail,
    quantityInfo,
    roofInfo,
  });
};

export const calculatedStructure = ({
  newImages,
  structureItem,
  dispatch,
  roofDetail,
  quantityInfo,
  roofInfo,
}) => {
  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  let totalStructure = newImages.length;
  const midClamp = totalStructure * structureItem.midClamp;
  const endClamp = totalStructure * structureItem.endClamp;
  const totalKilowatt = (
    totalStructure *
    (structureItem.structureWatt * (panel.pMax / 1000))
  ).toFixed(1);
  let noOfPvModule = newImages.length * structureItem.structureWatt;
  const rowDistance =
    roofDetail.customCapacityType === "Auto"
      ? structureItem.gap * 1000
      : roofDetail.rowDistance;
  const myObject = {
    images: newImages,
    structureType: "Single",
    totalKilowatt: totalKilowatt,
    totalStructure: totalStructure,
    customCapacity: totalKilowatt,
    pvModule: noOfPvModule,
    endClamp: endClamp,
    midClamp: midClamp,
    price: structureItem.price,
    mountingStructure: structureItem.name,
    railLength: 0,
    walkWayLength: 0,
    beam: 0,
    polls: 0,
    rails: 0,
    rowDistance: rowDistance,
    azimuth: 180,
    multipleStructure: [],
  };
  dispatch(
    updateRoofDetails({
      index: quantityInfo.roofNo,
      fields: myObject,
    })
  );

  const value = { ...roofDetail, ...myObject };
  generationLosses(value, quantityInfo, dispatch);
};

export const addNewImage = ({
  dispatch,
  roofInfo,
  currentPos,
  quantityInfo,
}) => {
  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[roofIndex] : [];
  const images = roofDetail?.images || [];

  let name = roofDetail.mountingStructure;

  const structureItem = roofStructureData.find((item) => item.name === name);
  let pixelMultiple = getPixelsPerMeter(roofInfo);

  const imgSrc = structureItem.structureImgSrc;
  const imgDimension = {
    height: structureItem.height * pixelMultiple,
    width: structureItem.width * pixelMultiple,
  };

  let azimuth = roofDetail.azimuth;
  let angleDegrees;
  if (azimuth >= 180) {
    angleDegrees = azimuth - 180;
  } else {
    angleDegrees = azimuth + 180;
  }

  const imageId =
    Date.now().toString(36) + Math.random().toString(36).substr(2, 5);

  const imagey = images.filter(
    (item) =>
      currentPos.y - 5 <= item.y &&
      currentPos.y + 5 >= item.y &&
      item.angleDegree === 0
  );
  const imagex = images.filter(
    (item) =>
      currentPos.x - imgDimension.width - 5 <= item.x &&
      currentPos.x + 5 >= item.x &&
      currentPos.y - 5 <= item.y &&
      currentPos.y + 5 >= item.y &&
      item.angleDegree === 0
  );
  let yValue = currentPos.y;
  let xValue = currentPos.x;
  if (imagey.length > 0) {
    yValue = imagey[0].y;
  }
  if (imagex.length > 0) {
    xValue = imagex[imagex.length - 1].x + imgDimension.width;
  }

  const newImage = {
    id: imageId,
    src: imgSrc,
    x: xValue,
    y: yValue,
    width: imgDimension.width,
    height: imgDimension.height,
    angleDegree: angleDegrees,
    type: name,
    gap: imgDimension.gap,
  };
  const newImages = [...images, newImage];

  const walkWayImages = roofDetail?.walkwayPlacement || [];
  if (
    structureItem.name === "Smith Pro L" ||
    structureItem.name === "Smith Through Rail L"
  ) {
    calculateLandscapePlacement({
      newImages,
      walkWayImages,
      structureItem,
      dispatch,
      roofDetail,
      quantityInfo,
    });
  } else if (
    structureItem.name === "Smith Pro P" ||
    structureItem.name === "Smith Through Rail P"
  ) {
    calculatePortraitPlacement({
      newImages,
      walkWayImages,
      structureItem,
      dispatch,
      roofDetail,
      quantityInfo,
    });
  } else if (structureItem.roofType === "Carport") {
    calculateCarportStructure({
      newImages,
      structureItem,
      dispatch,
      roofDetail,
      quantityInfo,
    });
  } else if (structureItem.name === "Customized") {
    calculateCustomizedStructure({
      newImages,
      structureItem,
      dispatch,
      roofDetail,
      quantityInfo,
    });
  }
};

export const handlePanelRotation = ({
  dispatch,
  abstacles,
  roofInfo,
  gridInfo,
  structureItem,
  designParameter,
  quantityInfo,
  value,
  changeAzimuth,
}) => {
  const roofData = quantityInfo.roofData;
  const index = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[index] : [];

  let limitCapacity = 0;
  let updateCondition = true;
  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );
  const structureWatt = panel.pMax;
  if (roofDetail.customCapacity !== 0 && designParameter.customCapacityCheck) {
    limitCapacity = (
      roofDetail.customCapacity /
      (structureItem.structureWatt * (structureWatt / 1000))
    ).toFixed();
  }

  let azimuth = roofDetail.azimuth;
  if (value === "up") {
    azimuth++;
  } else if (value === "down") {
    azimuth--;
  } else if (changeAzimuth) {
    azimuth = changeAzimuth;
  }

  let angleDegrees;
  if (azimuth >= 180) {
    angleDegrees = azimuth - 180;
  } else {
    angleDegrees = azimuth + 180;
  }

  /////////////////////////////////////////
  let row = roofDetail.blockRow;
  let col = roofDetail.blockCol;
  const colVal = col === 0 ? 10 : col;
  let factor = 500 + (500 % colVal);
  let walkway =
    gridInfo.unit === "m" ? roofDetail.walkWay : roofDetail.walkWay * 0.3048;
  let space = walkway * 20;
  /////////////////////////////////////////
  let currCol = 0;
  let currRow = 0;
  if (angleDegrees === 90 || angleDegrees === 270) angleDegrees += 0.5;
  if (
    angleDegrees <= 0 ||
    angleDegrees === 90 ||
    angleDegrees === 270 ||
    angleDegrees >= 360
  ) {
    return;
  }
  const roofPolygons = roofInfo?.value?.polygonCoordinates
    ? roofInfo.value.polygonCoordinates
    : [];
  const mapOption = roofInfo.value.mapOption;
  const zoom = mapOption.zoom;
  let pixelMultiple = 0;
  if (mapOption.mapTypeId === "gridView") {
    pixelMultiple = roofInfo.value.pixelValue * 3.28084;
  } else {
    if (zoom < 20) {
      pixelMultiple = 7.74 / (2 * (20 - zoom));
    } else if (zoom > 20) {
      pixelMultiple = 7.74 * 2 * (zoom - 20);
    } else {
      pixelMultiple = 7.74;
    }
  }
  const imgSrc = structureItem.structureImgSrc;
  const imgDimension = {
    height: structureItem.height * pixelMultiple,
    width: structureItem.width * pixelMultiple,
    gap: (roofDetail.rowDistance / 1000) * pixelMultiple,
  };
  ////////////////////////////////////
  walkway =
    roofDetail.walkWayType === "With" && roofDetail.roofType === "Shed Roof"
      ? pixelMultiple * walkway
      : 0;
  space = imgDimension.gap;
  let proP = [];
  let pInd = 0;
  ////////////////////////////////////

  let newImages = [];
  const polygonCoordinates = roofPolygons[index].updatedPoints;
  const adjustedPoints = polygonCoordinates.flatMap((point) => [
    point.x,
    point.y,
  ]);
  let maxX = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 0));
  let maxY = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 1));
  let minX = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 0));
  let minY = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 1));

  let angle = angleDegrees * (Math.PI / 180);

  if (
    (angleDegrees < 90 && angleDegrees > 0) ||
    (angleDegrees > 180 && angleDegrees < 270)
  ) {
    let x = maxX;

    let testY = minY + imgDimension.height * 0.3;

    let offVal = 0;
    // let offVal = maxY + maxX;
    while (x > minX - offVal) {
      let currX = x + designParameter.xValue;
      let currY = testY + designParameter.yValue;

      proP[pInd] = [];
      while (currX >= minX - offVal && currX <= maxX && currY <= maxY) {
        if (limitCapacity !== 0 && newImages.length >= limitCapacity) {
          updateCondition = false;
        }
        if (
          updateCondition &&
          canPlaceImageInside(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            polygonCoordinates
          ) &&
          isImageInsideObstacleRotation(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            abstacles
          )
        ) {
          newImages.push({
            id: newImages.length,
            src: imgSrc,
            x: currX,
            y: currY,
            width: imgDimension.width,
            height: imgDimension.height,
            type: structureItem.name,
            gap: imgDimension.gap,
            angleDegree: angleDegrees,
          });

          proP[pInd].push({ currX, currY });
        }
        currCol++;
        if (currCol === col) {
          currX += Math.abs((imgDimension.width + walkway) * Math.cos(angle));
          currY += Math.abs((imgDimension.width + walkway) * Math.sin(angle));
          currCol = 0;
        } else {
          currX += Math.abs(imgDimension.width * Math.cos(angle));
          currY += Math.abs(imgDimension.width * Math.sin(angle));
        }
      }
      // If the current proP[pInd] is not empty then increment
      if (proP[pInd].length > 0) pInd++;
      currCol = 0;
      currRow++;
      if (currRow % row === 0 && currRow !== 0) {
        x =
          x -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.cos(angle)
          ) -
          Math.abs((imgDimension.height + walkway + space) * Math.sin(angle));
        testY =
          testY -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.sin(angle)
          ) +
          Math.abs((imgDimension.height + walkway + space) * Math.cos(angle));
      } else {
        x =
          x -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.cos(angle)
          ) -
          Math.abs((imgDimension.height + space) * Math.sin(angle));
        testY =
          testY -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.sin(angle)
          ) +
          Math.abs((imgDimension.height + space) * Math.cos(angle));
      }
    }
    let y = testY;
    while (y < maxY) {
      let currX = x + designParameter.xValue;
      let currY = y + designParameter.yValue;

      currCol = 0;
      proP[pInd] = [];
      while (currX <= maxX && currY <= maxY) {
        if (limitCapacity !== 0 && newImages.length >= limitCapacity) {
          updateCondition = false;
        }
        if (
          updateCondition &&
          canPlaceImageInside(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            polygonCoordinates
          ) &&
          isImageInsideObstacleRotation(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            abstacles
          )
        ) {
          newImages.push({
            id: newImages.length,
            src: imgSrc,
            x: currX,
            y: currY,
            width: imgDimension.width,
            height: imgDimension.height,
            type: structureItem.name,
            gap: imgDimension.gap,
            angleDegree: angleDegrees,
          });

          proP[pInd].push({ currX, currY });
        }
        currCol++;
        if (currCol === col) {
          currX += Math.abs((imgDimension.width + walkway) * Math.cos(angle));
          currY += Math.abs((imgDimension.width + walkway) * Math.sin(angle));
          currCol = 0;
        } else {
          currX += Math.abs(imgDimension.width * Math.cos(angle));
          currY += Math.abs(imgDimension.width * Math.sin(angle));
        }
      }

      if (proP[pInd].length > 0) pInd++;
      currRow++;
      if (currRow % row === 0 && currRow !== 0) {
        x =
          x +
          0 * Math.abs(1 * imgDimension.width * Math.cos(angle)) -
          Math.abs((imgDimension.height + walkway + space) * Math.sin(angle));
        y =
          y +
          0 * Math.abs(1 * imgDimension.width * Math.sin(angle)) +
          Math.abs((imgDimension.height + walkway + space) * Math.cos(angle));
      } else {
        x =
          x +
          0 * Math.abs(1 * imgDimension.width * Math.cos(angle)) -
          Math.abs((imgDimension.height + space) * Math.sin(angle));
        y =
          y +
          0 * Math.abs(1 * imgDimension.width * Math.sin(angle)) +
          Math.abs((imgDimension.height + space) * Math.cos(angle));
      }
    }
  } else {
    let x = minX;
    let testY = minY + imgDimension.height * 0.3;

    let offVal = 0;
    while (x < maxX + offVal) {
      proP[pInd] = [];
      newImages = [...newImages];
      let currX = x + designParameter.xValue;
      let currY = testY + designParameter.yValue;

      currCol = 0;
      while (currX < maxX + offVal && currX >= minX && currY <= maxY) {
        if (limitCapacity !== 0 && newImages.length >= limitCapacity) {
          updateCondition = false;
        }
        if (
          updateCondition &&
          canPlaceImageInside(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            polygonCoordinates
          ) &&
          isImageInsideObstacleRotation(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            abstacles
          )
        ) {
          newImages.push({
            id: newImages.length,
            src: imgSrc,
            x: currX,
            y: currY,
            width: imgDimension.width,
            height: imgDimension.height,
            type: structureItem.name,
            gap: imgDimension.gap,
            angleDegree: angleDegrees,
          });
          proP[pInd].push({ currX, currY });
        }

        currCol++;
        if (currCol === col) {
          currX -= Math.abs((imgDimension.width + walkway) * Math.cos(angle));
          currY += Math.abs((imgDimension.width + walkway) * Math.sin(angle));
          currCol = 0;
        } else {
          currX -= Math.abs(imgDimension.width * Math.cos(angle));
          currY += Math.abs(imgDimension.width * Math.sin(angle));
        }
      }

      // If the current proP[pInd] is not empty then increment
      if (proP[pInd].length > 0) pInd++;

      currRow++;
      if (currRow % row === 0 && currRow !== 0) {
        x =
          x +
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.cos(angle)
          ) +
          Math.abs((imgDimension.height + walkway + space) * Math.sin(angle));
        testY =
          testY -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.sin(angle)
          ) +
          Math.abs((imgDimension.height + walkway + space) * Math.cos(angle));
      } else {
        x =
          x +
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.cos(angle)
          ) +
          Math.abs((imgDimension.height + space) * Math.sin(angle));
        testY =
          testY -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.sin(angle)
          ) +
          Math.abs((imgDimension.height + space) * Math.cos(angle));
      }
    }
    let y = testY;
    while (y < maxY) {
      proP[pInd] = [];
      newImages = [...newImages];
      let currX = x + designParameter.xValue;
      let currY = y + designParameter.yValue;
      currCol = 0;
      while (currX >= minX && currY <= maxY) {
        if (limitCapacity !== 0 && newImages.length >= limitCapacity) {
          updateCondition = false;
        }
        if (
          updateCondition &&
          canPlaceImageInside(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            polygonCoordinates
          ) &&
          isImageInsideObstacleRotation(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            abstacles
          )
        ) {
          newImages = [...newImages];
          newImages.push({
            id: newImages.length,
            src: imgSrc,
            x: currX,
            y: currY,
            width: imgDimension.width,
            height: imgDimension.height,
            type: structureItem.name,
            gap: imgDimension.gap,
            angleDegree: angleDegrees,
          });
          proP[pInd].push({ currX, currY });
        }
        currCol++;
        if (currCol === col) {
          currX -= Math.abs((imgDimension.width + walkway) * Math.cos(angle));
          currY += Math.abs((imgDimension.width + walkway) * Math.sin(angle));
          currCol = 0;
        } else {
          currX -= Math.abs(imgDimension.width * Math.cos(angle));
          currY += Math.abs(imgDimension.width * Math.sin(angle));
        }
      }

      if (proP[pInd].length > 0) pInd++;
      currRow++;
      if (currRow % row === 0 && currRow !== 0) {
        x =
          x +
          0 * imgDimension.width * Math.cos(angle) +
          Math.abs((imgDimension.height + walkway + space) * Math.sin(angle));
        y =
          y +
          0 * Math.abs(imgDimension.width * Math.sin(angle)) +
          Math.abs((imgDimension.height + walkway + space) * Math.cos(angle));
      } else {
        x =
          x +
          0 * imgDimension.width * Math.cos(angle) +
          Math.abs((imgDimension.height + space) * Math.sin(angle));
        y =
          y +
          0 * Math.abs(imgDimension.width * Math.sin(angle)) +
          Math.abs((imgDimension.height + space) * Math.cos(angle));
      }
    }
  }
  if (proP.length > 0 && proP[pInd].length === 0) proP.pop();

  // Panel Calculations
  calculatedRotateStructure({
    newImages,
    proP,
    imgDimension,
    structureItem,
    dispatch,
    quantityInfo,
    roofInfo,
    roofDetail,
    azimuth,
  });
};

export const calculatedRotateStructure = ({
  newImages,
  proP,
  imgDimension,
  structureItem,
  dispatch,
  quantityInfo,
  roofInfo,
  roofDetail,
  azimuth,
}) => {
  let groupArray = [];

  if (
    structureItem.name === "Smith Pro P" ||
    structureItem.name === "Smith Through Rail P" ||
    structureItem.name === "Single Carport" ||
    structureItem.name === "Double Carport" ||
    structureItem.name === "Customized"
  ) {
    groupArray = proP;
  } else {
    let test = [...newImages];
    for (let i = 0; i < test.length; i++) {
      test[i] = { ...test[i], group: -1 };
    }

    let group = 0;
    let testAngle =
      newImages.length > 0 ? newImages[0].angleDegree : roofDetail.azimuth;
    test.forEach((item) => {
      if (item.group === -1) {
        item.group = group;
        test.forEach((item2) => {
          if (
            item2.group === -1 &&
            ((item.x > item2.x &&
              ((testAngle >= 0 && testAngle < 90) ||
                (testAngle > 180 && testAngle < 270))) ||
              (item.x < item2.x &&
                ((testAngle > 90 && testAngle < 180) ||
                  (testAngle > 270 && testAngle < 360))))
          ) {
            let angle = Math.round(
              Math.atan2(item.y - item2.y, item.x - item2.x) * (180 / Math.PI)
            );
            if (testAngle >= 0 && testAngle < 90) angle += 90;
            else if (testAngle >= 90 && testAngle < 270) angle += 270;
            else angle += 450;
            // Keep tolerance of +-3 degrees
            if (angle >= testAngle - 3 && angle <= testAngle + 3) {
              item2.group = group;
            }
          }
        });
        group++;
      }
    });

    for (let i = 0; i < group; i++) {
      groupArray.push([]);
    }
    test.forEach((item) => {
      groupArray[item.group].push({ x: item.x, y: item.y });
    });
  }

  let endClamps =
    structureItem.name === "Single Carport" ||
    structureItem.name === "Double Carport" ||
    structureItem.name === "Customized"
      ? groupArray.length * 8
      : groupArray.length * 4;

  let midClamps = 0;
  let beams = 0;
  let jointer = 0;
  let mid = 0;
  let end = 0;
  let col = 1;

  groupArray.forEach((item) => {
    for (let i = 0; i < item.length; i++) {
      const ele = item[i];
      const ele2 = i < item.length - 1 ? item[i + 1] : ele;
      const check = Number(imgDimension.width.toFixed(2));

      if (structureItem.orientation === "Portrait") {
        const len = Number(
          Math.sqrt(
            Math.pow(ele.currX - ele2.currX, 2) +
              Math.pow(ele.currY - ele2.currY, 2)
          ).toFixed(2)
        );
        if (
          structureItem.name === "Single Carport" ||
          structureItem.name === "Double Carport"
        ) {
          if (len === check) {
            mid += 16;
            col++;
          } else {
            mid += 12;
            end += 4 * structureItem.rowFrame;
            if (structureItem.mountStructure) {
              const poll = col;
              beams += poll + 1;
              jointer += poll - 1;
            }
            col = 1;
          }
        } else {
          if (len === check) {
            mid += 2 * structureItem.rowFrame;
            col++;
          } else {
            end += 4 * structureItem.rowFrame;
            if (structureItem.mountStructure) {
              const poll = Number((col / 3).toFixed());
              beams += poll + 1;
              jointer += poll - 1;
            }
            col = 1;
          }
        }
      } else {
        const len = Number(
          Math.sqrt(
            Math.pow(ele.x - ele2.x, 2) + Math.pow(ele.y - ele2.y, 2)
          ).toFixed(2)
        );
        const check = Number(
          (imgDimension.height + imgDimension.gap).toFixed(2)
        );

        if (len === check) {
          mid += 2;
        } else {
          end += 4;
        }
      }
    }
  });

  const myObject = {
    images: newImages,
    structureType: "Single",
    totalKilowatt: 0,
    totalStructure: "--",
    pvModule: 0,
    endClamp: 0,
    midClamp: 0,
    price: structureItem.price,
    mountingStructure: structureItem.name,
    railLength: 0,
    walkWayLength: 0,
    beam: 0,
    polls: 0,
    rails: 0,
    azimuth: azimuth,
    rowDistance: roofDetail.rowDistance,
    multipleStructure: [],
  };

  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  if (
    structureItem.name === "Single Carport" ||
    structureItem.name === "Double Carport"
  ) {
    midClamps = 0;
    groupArray.forEach((item) => {
      beams += item.length + 1;
      midClamps += item.length * 16 - 4;
    });
  }
  if (structureItem.name === "Customized") {
    midClamps = 0;
    groupArray.forEach((item) => {
      midClamps += item.length * 4 - 4;
      beams += Number((item.length / 3).toFixed(0)) + 1;
    });
  }
  if (
    structureItem.name === "Smith Pro L" ||
    structureItem.name === "Smith Pro P"
  ) {
    const totalRails = end + mid;
    myObject.rails = totalRails;
  } else if (structureItem.name === "Smith Through Rail L") {
    const railLength = Number(
      newImages.length * 2 * structureItem.height * 3.28084 + (end * 50) / 304.8
    );
    const fullRailLength = Number(
      (railLength + (railLength * 4) / 100).toFixed(1)
    );
    myObject.railLength = fullRailLength;
  } else if (structureItem.name === "Smith Through Rail P") {
    const railLength = Number(
      newImages.length * 2 * structureItem.width * 3.28084 + (end * 50) / 304.8
    );
    const fullRailLength = Number(
      (railLength + (railLength * 4) / 100).toFixed(1)
    );
    myObject.railLength = fullRailLength;
  } else if (
    structureItem.name === "Customized" ||
    structureItem.name === "Single Carport" ||
    structureItem.name === "Double Carport"
  ) {
    const fullRailLength = Number(
      (
        newImages.length * 4 * structureItem.width * 3.28084 +
        (endClamps * 50) / 304.8
      ).toFixed(2)
    );
    myObject.railLength = fullRailLength;
    myObject.beam = beams;
    myObject.polls = beams * 3;
  }

  if (structureItem.roofType !== "Flat Roof") {
    myObject.midClamp = mid;
    myObject.endClamp = end;
  }
  const totalKilowatt = (
    newImages.length *
    (structureItem.structureWatt * (panel.pMax / 1000))
  ).toFixed(1);

  myObject.pvModule = newImages.length * structureItem.structureWatt;
  myObject.totalKilowatt = totalKilowatt;

  proP = { ...proP };
  dispatch(
    updateRoofDetails({
      index: quantityInfo.roofNo,
      fields: {
        ...myObject,
        proP: proP,
      },
    })
  );
  proP = Object.values(proP);

  const value = { ...roofDetail, ...myObject };
  generationLosses(value, quantityInfo, dispatch);
  console.log(jointer, midClamps);
};

export const isImageInsideObstacleRotation = (
  x,
  y,
  width,
  height,
  angle,
  obstacleCoordinates
) => {
  const topLeftX = x;
  const topLeftY = y;
  const topRightX = x + width * Math.cos(angle);
  const topRightY = y + width * Math.sin(angle);
  const bottomLeftX = x - height * Math.sin(angle);
  const bottomLeftY = y + height * Math.cos(angle);
  const bottomRightX = bottomLeftX + width * Math.cos(angle);
  const bottomRightY = bottomLeftY + width * Math.sin(angle);
  for (let i = 0; i < obstacleCoordinates.length; i++) {
    const polygon = obstacleCoordinates[i].updatedPoints;

    if (
      isPointInPolygon(topLeftX, topLeftY, polygon) ||
      isPointInPolygon(topRightX, topRightY, polygon) ||
      isPointInPolygon(bottomLeftX, bottomLeftY, polygon) ||
      isPointInPolygon(bottomRightX, bottomRightY, polygon)
    ) {
      return false; // Image intersects with obstacle
    }

    for (let j = 0; j < polygon.length; j++) {
      const line = [polygon[j], polygon[(j + 1) % polygon.length]];

      if (
        doLinesIntersect(line, [
          { x: topLeftX, y: topLeftY },
          { x: topRightX, y: topRightY },
        ]) ||
        doLinesIntersect(line, [
          { x: topRightX, y: topRightY },
          { x: bottomRightX, y: bottomRightY },
        ]) ||
        doLinesIntersect(line, [
          { x: bottomRightX, y: bottomRightY },
          { x: bottomLeftX, y: bottomLeftY },
        ]) ||
        doLinesIntersect(line, [
          { x: bottomLeftX, y: bottomLeftY },
          { x: topLeftX, y: topLeftY },
        ])
      ) {
        return false; // Image intersects with obstacle line
      }
    }
  }

  return true;
};

export const canPlaceImageInside90 = (
  x,
  y,
  width,
  height,
  angle,
  polygonCoordinates
) => {
  const topLeftX = x;
  const topLeftY = y;
  const topRightX = x + width * Math.cos(angle);
  const topRightY = y - width * Math.sin(angle);
  const bottomLeftX = x - height * Math.sin(angle);
  const bottomLeftY = y + height * Math.cos(angle);
  const bottomRightX = bottomLeftX + width * Math.cos(angle);
  const bottomRightY = bottomLeftY + width * Math.sin(angle);
  if (
    isPointInPolygon(topLeftX, topLeftY, polygonCoordinates) &&
    isPointInPolygon(topRightX, topRightY, polygonCoordinates) &&
    isPointInPolygon(bottomLeftX, bottomLeftY, polygonCoordinates) &&
    isPointInPolygon(bottomRightX, bottomRightY, polygonCoordinates)
  ) {
    return true;
  }
  return false;
};

export const canPlaceImageInside = (
  x,
  y,
  width,
  height,
  angle,
  polygonCoordinates
) => {
  const topLeftX = x;
  const topLeftY = y;
  const topRightX = x + width * Math.cos(angle);
  const topRightY = y + width * Math.sin(angle);
  const bottomLeftX = x - height * Math.sin(angle);
  const bottomLeftY = y + height * Math.cos(angle);
  const bottomRightX = bottomLeftX + width * Math.cos(angle);
  const bottomRightY = bottomLeftY + width * Math.sin(angle);
  if (
    isPointInPolygon(topLeftX, topLeftY, polygonCoordinates) &&
    isPointInPolygon(topRightX, topRightY, polygonCoordinates) &&
    isPointInPolygon(bottomLeftX, bottomLeftY, polygonCoordinates) &&
    isPointInPolygon(bottomRightX, bottomRightY, polygonCoordinates)
  ) {
    return true;
  }
  return false;
};

export const handlePolygonLine = (polygon) => {
  const data = polygon;
  let values = [data[0].x, data[0].y, data[1].x, data[1].y];
  let minY = data[0].y;
  let maxIndex = 0;
  let minIndex = 0;
  for (let i = 0; i < data.length; i++) {
    if (data[i].y < minY) {
      minY = data[i].y;
      minIndex = i;
    }
  }

  if (minIndex === 0) {
    const firstSlope = slopefun(
      data[minIndex].x,
      data[minIndex].y,
      data[minIndex + 1].x,
      data[minIndex + 1].y
    );
    const secondSlope = slopefun(
      data[minIndex].x,
      data[minIndex].y,
      data[data.length - 1].x,
      data[data.length - 1].y
    );
    if (firstSlope > secondSlope) {
      maxIndex = minIndex + 1;
    } else {
      maxIndex = data.length - 1;
    }
  } else {
    const firstSlope = slopefun(
      data[minIndex].x,
      data[minIndex].y,
      data[minIndex + 1].x,
      data[minIndex + 1].y
    );
    const secondSlope = slopefun(
      data[minIndex].x,
      data[minIndex].y,
      data[minIndex - 1].x,
      data[minIndex - 1].y
    );
    if (firstSlope > secondSlope) {
      maxIndex = minIndex + 1;
    } else {
      maxIndex = minIndex - 1;
    }
  }
  if (data[minIndex].x < data[maxIndex].x) {
    values = [
      data[minIndex].x,
      data[minIndex].y,
      data[maxIndex].x,
      data[maxIndex].y,
    ];
  } else {
    values = [
      data[maxIndex].x,
      data[maxIndex].y,
      data[minIndex].x,
      data[minIndex].y,
    ];
  }
  values = [data[0].x, data[0].y, data[1].x, data[1].y];

  return values;
};

const slopefun = (x1, y1, x2, y2) => {
  let angle;
  if (x1 < x2) {
    const m = (y2 - y1) / (x2 - x1);
    angle = Math.atan(m);
  } else {
    const m = (y1 - y2) / (x1 - x2);
    angle = Math.atan(m);
  }
  return angle;
};
